import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { liquidityStreamedDataSelectors } from 'widgets/liquiditySummary/store/data/streamSlice';
import { VolumeCapsuleConfigState } from 'widgets/liquiditySummary/volumeCapsule/state/config/VolumeCapsuleConfigState';
import { VolumeCapsuleContent } from 'widgets/liquiditySummary/volumeCapsule/components/VolumeCapsuleContent';
import { buildData } from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';
import { useExchangeRate } from 'app/hooks';

const { useSymbolStreamedData } = liquidityStreamedDataSelectors;

export function VolumeCapsuleMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol, qty } = props;
    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsuleConfigSlice<VolumeCapsuleConfigState>();
    const exchangeRate = useExchangeRate();

    const streamData = useSymbolStreamedData(symbol, config, qty);
    const chartData = buildData(streamData, exchangeRate).volumeCapsuleData;

    return (
        <VolumeCapsuleContent
            chartData={chartData}
            config={config}
            dispatchConfigChanged={dispatchConfigChanged}
        />
    );
}
